import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Enregistrer le Service Worker pour PWA
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ OrderLab est prêt pour le mode offline!');
  },
  onUpdate: (registration) => {
    console.log('🔄 Nouvelle version disponible!');
    // Optionnel: Afficher un toast pour notifier l'utilisateur
    // et proposer de recharger pour avoir la nouvelle version
  }
});

// Détecter si l'app peut être installée
serviceWorkerRegistration.checkInstallPrompt();
